// client/src/services/billingTransactionService.js
import api from './api';

const billingTransactionService = {
  
  
    // Add a new method to get transactions for a specific bylaw
    getBylawTransactions: async (bylawId) => {
      const response = await api.get(`/billing-transactions/bylaw/${bylawId}`);
      return response.data;
    },
    
  getBillingTransactions: async () => {
    const response = await api.get('/billing-transactions');
    return response.data;
  },
  
  getBillingTransaction: async (id) => {
    const response = await api.get(`/billing-transactions/${id}`);
    return response.data;
  },
  
  createBillingTransaction: async (transactionData) => {
    // This method now expects transactionData to have payment_bylaw_id and payment_item_id
    // instead of faculty_id and name
    const response = await api.post('/billing-transactions', transactionData);
    return response.data;
  },
  
  updateBillingTransaction: async (id, transactionData) => {
    // This method now expects transactionData to have payment_bylaw_id and payment_item_id
    // instead of faculty_id and name
    const response = await api.put(`/billing-transactions/${id}`, transactionData);
    return response.data;
  },
  
  deleteBillingTransaction: async (id) => {
    const response = await api.delete(`/billing-transactions/${id}`);
    return response.data;
  }
};

export default billingTransactionService;